<template>
  <el-input
    v-model="baseCount"
    :disabled="true"
    size="small"
  >
  </el-input>
</template>

<script>
  export default {
    props: {
      itemBaseCount: {
        type: Number,
        default() {
          return 0;
        },
        required: false,
      },
    },
    data() {
      return {
        baseCount: 0,
      };
    },
    watch: {
      itemBaseCount: {
        handler(count) {
          this.baseCount = count;
        },
        deep: true
      }
    },
    mounted() {
      // debugger
      this.baseCount = this.itemBaseCount;
    },
  };
</script>
